import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Association } from "src/interfaces/Common";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import useSWR from "swr";

export const useModuleActivityAddEdit = (dataDetail?: any) => {
  const { id, IdPlan } = useParams();

  const [openAssociations, setOpenAssociations] = useState<
    boolean | Association
  >(false);
  const [activityAssociation, setActivityAssociation] = useState<any>([]);
  const [courseAssociation, setCourseAssociation] = useState<any>([]);
  const [pathAssociation, setPathAssociation] = useState<any>([]);
  const [editionAssociation, setEditionAssociation] = useState<any>([]);
  const [inputForm, setInputForm] = useState<any>();
  const [showError, setShowError] = useState(false);
  const [configActivityType, setConfigActivityType] =
    useState<string>("activity_type");

  const hasBlendedEditionActivity = activityAssociation.some(
    (activity: any) =>
      activity?.type === "DA_PHYSICAL_CLASS" ||
      activity?.type === "DA_VIRTUAL_CLASS",
  );

  useEffect(() => {
    if (showError) {
      setShowError(false);
    }
  }, [
    activityAssociation,
    courseAssociation,
    pathAssociation,
    editionAssociation,
    inputForm,
  ]);

  useEffect(() => {
    if (dataDetail) {
      setActivityAssociation(dataDetail?.lo_ids?.activities || []);
      setCourseAssociation(dataDetail?.lo_ids?.courses || []);
      setPathAssociation(dataDetail?.lo_ids?.paths || []);
      setEditionAssociation(dataDetail?.lo_ids?.editions || []);
    }
  }, [dataDetail]);

  const { data: detailPlan } = useSWR(
    `${ServicesURL.getPlan
      .replace(":corporateId", id || "")
      .replace(":planId", IdPlan || "")}`,
    (url: string) => fetcher(url, MethodType.GET),
  );

  const tableIsMultipleCheck =
    detailPlan?.fund?.catalog_association_type === "MULTIPLE" ? true : false;

  const setOpenAssociation = (accessorKey: string, value: boolean) => {
    let isStandAlone = false;
    if (
      inputForm?.delivery_mode_type === "ACTION_LEARNING" ||
      inputForm?.delivery_mode_type === "SELF_LEARNING" ||
      inputForm?.delivery_mode_type === "TRAINING_SIDE_BY_SIDE" ||
      inputForm?.delivery_mode_type === "TRAINING_ON_THE_JOB" ||
      inputForm?.delivery_mode_type === "COACHING" ||
      inputForm?.delivery_mode_type === "TAD" ||
      inputForm?.delivery_mode_type === "BLENDED"
    ) {
      isStandAlone = true;
    }

    switch (accessorKey) {
      case "activities":
        let urlActivityType: string = "activity_type";
        if (configActivityType === "activity_type_founded_training_digit") {
          urlActivityType =
            "DA_XAPI,DA_SCORM,DA_EXTERNAL_RES,DA_YOUTUBE,DA_LINKEDIN,DA_SURVEY,DA_URL_RES,DA_MATERIAL,DA_GOALS,DA_MEETING,DA_FINAL_BALANCE";
        } else if (configActivityType === "activity_type_founded_training") {
          urlActivityType = "DA_PHYSICAL_CLASS,DA_VIRTUAL_CLASS";
        } else if (configActivityType === "activity_type_phisical") {
          urlActivityType = "DA_PHYSICAL_CLASS";
        } else if (configActivityType === "activity_type_virtual") {
          urlActivityType = "DA_VIRTUAL_CLASS";
        } else if (configActivityType === "activity_type_blended") {
          urlActivityType =
            "DA_XAPI,DA_SCORM,DA_EXTERNAL_RES,DA_YOUTUBE,DA_LINKEDIN,DA_SURVEY,DA_URL_RES,DA_MATERIAL,DA_GOALS,DA_MEETING,DA_FINAL_BALANCE,DA_VIRTUAL_CLASS,DA_PHYSICAL_CLASS";
        }
        setOpenAssociations(
          value
            ? {
                accessorKey: "activities",
                mediaType: "activities",
                type: "table",
                titleKey: "activities-association",
                pageId: PagesID["corporate.catalog.activities"],
                manageConfigs: {
                  is_standalone: {
                    hasFilter: false,
                  },
                  type: {
                    optionsKey: configActivityType,
                  },
                },
                multiChoice: tableIsMultipleCheck,
                defaultFilters: { type: urlActivityType },
                service: `${ServicesURL.getActivities.replace(
                  ":idCorporate",
                  id || "",
                )}${isStandAlone ? "?is_standalone=true" : ""}`,
              }
            : value,
        );
        break;
      case "courses":
        let toj_specialization = false;
        if (
          inputForm?.delivery_mode_type === "ACTION_LEARNING" ||
          inputForm?.delivery_mode_type === "TRAINING_SIDE_BY_SIDE" ||
          inputForm?.delivery_mode_type === "TRAINING_ON_THE_JOB" ||
          inputForm?.delivery_mode_type === "COACHING"
        ) {
          toj_specialization = true;
        }
        setOpenAssociations(
          value
            ? {
                accessorKey: "courses",
                mediaType: "courses",
                type: "table",
                titleKey: "course-association",
                pageId: PagesID["corporate.catalog.courses"],
                manageConfigs: {
                  is_standalone: {
                    hasFilter: false,
                  },
                },
                multiChoice: tableIsMultipleCheck,
                service: `${ServicesURL.getCoursesAssociation.replace(
                  ":idCorporate",
                  id || "",
                )}${isStandAlone ? "?is_standalone=true&" : "?"}toj_specialization=${toj_specialization}`,
              }
            : value,
        );
        break;
      case "paths":
        setOpenAssociations(
          value
            ? {
                accessorKey: "paths",
                mediaType: "paths",
                type: "table",
                titleKey: "path-association",
                pageId: PagesID["corporate.catalog.path"],
                manageConfigs: {
                  is_standalone: {
                    hasFilter: false,
                  },
                },
                multiChoice: tableIsMultipleCheck,
                service: `${ServicesURL.getPaths.replace(
                  ":idCorporate",
                  id || "",
                )}${isStandAlone ? "?is_standalone=true" : ""}`,
              }
            : value,
        );
        break;
      case "editions":
        let typeEdition = "PHYSICAL";
        if (inputForm?.delivery_mode_type === "VIRTUAL_CLASSROOM") {
          typeEdition = "VIRTUAL";
        }
        setOpenAssociations(
          value
            ? {
                accessorKey: "editions",
                mediaType: "editions",
                type: "table",
                titleKey: "edition-association",
                pageId: PagesID["corporate.foundedtraining-editions"],
                manageConfigs: {
                  is_standalone: {
                    hasFilter: false,
                  },
                },
                multiChoice: tableIsMultipleCheck,
                service:
                  ServicesURL.getEditions +
                  `?corporateId=${id || ""}&type=${typeEdition}`,
              }
            : value,
        );
        break;
    }
  };

  const getValues = (accessorKey: string) => {
    switch (accessorKey) {
      case "activities":
        return activityAssociation;
      case "courses":
        return courseAssociation;
      case "paths":
        return pathAssociation;
      case "editions":
        return editionAssociation;
    }
  };

  const handleAssociation = (accessorKey: string, value: any) => {
    switch (accessorKey) {
      case "activities":
        const objActivitiesAssociation: any = Object.keys(value).map(
          (key: string) => {
            if (key.includes("||")) {
              return {
                id: key.split("||")[0],
                label: key.split("||")[1],
                duration: key.split("||")[2],
                type: key.split("||")[3],
              };
            }
          },
        );
        setActivityAssociation(objActivitiesAssociation);
        break;
      case "courses":
        const objToCoursesAssociation: any = Object.keys(value).map(
          (key: string) => {
            if (key.includes("||")) {
              return {
                id: key.split("||")[0],
                label: key.split("||")[1],
                duration: key.split("||")[2],
                type: key.split("||")[3],
              };
            }
          },
        );
        setCourseAssociation(objToCoursesAssociation);
        break;
      case "paths":
        const objToPathsAssociation: any = Object.keys(value).map(
          (key: string) => {
            if (key.includes("||")) {
              return {
                id: key.split("||")[0],
                label: key.split("||")[1],
                duration: key.split("||")[2],
                type: key.split("||")[3],
              };
            }
          },
        );
        setPathAssociation(objToPathsAssociation);
        break;
      case "editions":
        const objToEditionAssociation: any = Object.keys(value).map(
          (key: string) => {
            if (key.includes("||")) {
              return {
                id: key.split("||")[0],
                label:
                  key.split("||")[1] === "null" ? null : key.split("||")[1],
                activity_duration: key.split("||")[2],
                lo_id: key.split("||")[3],
                type: key.split("||")[3],
              };
            }
          },
        );
        setEditionAssociation(objToEditionAssociation);
        break;
    }
  };

  const handleDelete = (accessorKey: string, e: any) => {
    switch (accessorKey) {
      case "activities":
        setActivityAssociation(
          activityAssociation.filter((element: any) => element.id !== e.id),
        );
        break;
      case "courses":
        setCourseAssociation(
          courseAssociation.filter((element: any) => element.id !== e.id),
        );
        break;
      case "paths":
        setPathAssociation(
          pathAssociation.filter((element: any) => element.id !== e.id),
        );
        break;
      case "editions":
        setEditionAssociation(
          editionAssociation.filter((element: any) => element.id !== e.id),
        );
        break;
    }
  };

  const handleClearAssociation = () => {
    setActivityAssociation([]);
    setCourseAssociation([]);
    setPathAssociation([]);
    setEditionAssociation([]);
  };

  const inputsException = (col: any, inputForm: any) => {
    // Cambia l'accesor key del file di config in base alla MODALITA DI EROGAZIONE
    if (inputForm.delivery_mode_type === "WORKSHOP") {
      setConfigActivityType("activity_type_founded_training");
    } else if (inputForm.delivery_mode_type === "BLENDED") {
      setConfigActivityType("activity_type_blended");
    } else if (inputForm.delivery_mode_type === "PHYSICAL_CLASSROOM") {
      setConfigActivityType("activity_type_phisical");
    } else if (inputForm.delivery_mode_type === "VIRTUAL_CLASSROOM") {
      setConfigActivityType("activity_type_virtual");
    } else if (
      inputForm.delivery_mode_type === "SELF_LEARNING" ||
      inputForm.delivery_mode_type === "TAD"
    ) {
      setConfigActivityType("activity_type_founded_training_digit");
    } else {
      setConfigActivityType("activity_type");
    }

    if (
      inputForm?.delivery_mode_type &&
      dataDetail?.delivery_mode_type &&
      inputForm?.delivery_mode_type !== dataDetail?.delivery_mode_type
    ) {
    }
    const time = inputForm?.duration;
    setInputForm(inputForm);
    if (
      !inputForm["delivery_mode_type"] &&
      (col.accessorKey === "activities" ||
        col.accessorKey === "courses" ||
        col.accessorKey === "paths" ||
        col.accessorKey === "editions")
    ) {
      col.required = false;
      return {};
    }
    if (
      (inputForm["delivery_mode_type"] === "PHYSICAL_CLASSROOM" ||
        inputForm["delivery_mode_type"] === "VIRTUAL_CLASSROOM") &&
      (col.accessorKey === "courses" || col.accessorKey === "paths")
    ) {
      col.required = false;
      return {};
    }
    if (
      (inputForm["delivery_mode_type"] === "ACTION_LEARNING" ||
        inputForm["delivery_mode_type"] === "TRAINING_SIDE_BY_SIDE" ||
        inputForm["delivery_mode_type"] === "TRAINING_ON_THE_JOB" ||
        inputForm["delivery_mode_type"] === "COACHING") &&
      (col.accessorKey === "activities" ||
        col.accessorKey === "paths" ||
        col.accessorKey === "editions")
    ) {
      return {};
    }
    if (
      (inputForm["delivery_mode_type"] === "SELF_LEARNING" ||
        inputForm["delivery_mode_type"] === "TAD") &&
      col.accessorKey === "editions"
    ) {
      return {};
    }
    if (
      inputForm["delivery_mode_type"] === "BLENDED" &&
      (col.accessorKey === "courses" || col.accessorKey === "paths")
    ) {
      col.required = false;
      return {};
    }
    if (
      inputForm["delivery_mode_type"] === "BLENDED" &&
      col.accessorKey === "editions" &&
      !hasBlendedEditionActivity
    ) {
      col.required = false;
      return {};
    }
    if (!dataDetail && col.accessorKey === "id") {
      return {};
    }
    if (
      col.accessorKey === "activities" &&
      !tableIsMultipleCheck &&
      activityAssociation.length === 1 &&
      calculateDuration(activityAssociation) < time
    ) {
      col.error = "associations_error";
      setShowError(true);
    }
    if (
      col.accessorKey === "paths" &&
      !tableIsMultipleCheck &&
      pathAssociation.length === 1 &&
      calculateDuration(pathAssociation) < time
    ) {
      col.error = "associations_error";
      setShowError(true);
    }
    if (
      col.accessorKey === "courses" &&
      !tableIsMultipleCheck &&
      courseAssociation.length === 1 &&
      calculateDuration(courseAssociation) < time
    ) {
      col.error = "associations_error";
      setShowError(true);
    }
    if (
      col.accessorKey === "editions" &&
      !tableIsMultipleCheck &&
      editionAssociation.length === 1 &&
      calculateDuration(editionAssociation) < time
    ) {
      col.error = "associations_error";
      setShowError(true);
    }

    if (col.accessorKey === "delivery_mode_type") {
      col.callBack = (e: any, row: any) => {
        handleClearAssociation();
        return {
          ...inputForm,
          delivery_mode_type: e,
        };
      };
    }
    return col;
  };

  const calculateDuration = (array: any[]) => {
    const result = array.reduce((accumulator, currentValue) => {
      const duration = Number(
        currentValue?.duration || currentValue?.activity_duration || 0,
      );
      return duration + accumulator;
    }, 0);
    return result;
  };

  return {
    activityAssociation,
    courseAssociation,
    pathAssociation,
    editionAssociation,
    openAssociations,
    setOpenAssociation,
    handleAssociation,
    handleDelete,
    handleClearAssociation,
    inputsException,
    getValues,
    setShowError,
    calculateDuration,
    showError,
    setActivityAssociation,
    setCourseAssociation,
    setPathAssociation,
    setEditionAssociation,
  };
};
